import React from 'react'
import DownloadButton from './download-icon/DownloadIcon'
import { StyledLogo } from './wsc-logo/StyledLogo.styled'
import LogoLine from './wsc-logo/LogoLine'
import PowerByWsc from './wsc-logo/PowerByWsc'
import WscLogo from './wsc-logo/WscLogo'
import { StyledMediaContainer } from './MediaContainer.style'

export interface IMediaContainer {
  isFadeIn?: boolean
  onClickDownload: () => void
  children: React.ReactNode
}

export const MediaContainer = ({
  isFadeIn,
  onClickDownload,
  children,
}: IMediaContainer): JSX.Element => {
  return (
    <StyledMediaContainer>
      {children}
      <DownloadButton onClick={onClickDownload} isFadeIn={isFadeIn} />

      <StyledLogo isFadeIn={isFadeIn} data-type="logo">
        <WscLogo />
        <LogoLine />
        <PowerByWsc />
      </StyledLogo>
    </StyledMediaContainer>
  )
}

export default MediaContainer
